module.exports = __webpack_public_path__ + "assets/img/title-29cdeb14.png";